export default __webpack_public_path__ + "e4bf99bbe563b84d7ee3198f23c4f560.png";